<template>
  <div
    class="_hunian"
    :style="'height: ' + htmlHeight + 'px;width: ' + htmlWidth + 'px;'"
  >
    <pages :index="pageIndex">
      <!-- 请在手机端打开链接 -->
      <page index="mobile" class="view _mobile">
        <img
          class="_bg"
          src="http://minio.elfsack.com/h5material/2022shtg/pc_bg.png"
        />
        <div class="_qc_v animated fadeIn">
          <div class="_qc_t">请用手机扫码打开~</div>
          <img
            class="_qc_p"
            src="http://minio.elfsack.com/h5material/2022shtg/pc_qc.png"
          />
        </div>
      </page>
      <!-- view1 -->
      <page index="view1" class="view view1">
        <canvas id="canvas"></canvas>
        <img
          class="_bg"
          src="http://minio.elfsack.com/h5material/2022shtg/1_bg.png"
        />
        <img
          class="_1_title animated bounceIn"
          src="http://minio.elfsack.com/h5material/2022shtg/1_title.png"
          :style="
            'height:' + (htmlHeight * 0.25 - (htmlWidth - 320) * 0.6) + 'px'
          "
        />
        <div
          :style="
            'position: absolute;bottom: 4%;width: 100%;text-align:center;height:' +
            (htmlHeight * 0.15 - (htmlWidth - 320) * 0.7) +
            'px'
          "
        >
          <div
            class="animated pulse infinite"
            style="height: 65%; max-width: 80%; display: inline-block"
            @click="clickView1"
          >
            <img
              class="_1_btn animated bounceIn"
              src="http://minio.elfsack.com/h5material/2022shtg/1_btn.png"
            />
            <img
              class="_1_tip animated bounceInRight"
              src="http://minio.elfsack.com/h5material/2022shtg/1_tip.png"
            />
          </div>
          <br />
          <img
            class="_1_logo animated fadeInUp"
            src="http://minio.elfsack.com/h5material/2022shtg/1_logo.png"
          />
        </div>
      </page>

      <!-- view2 -->
      <page index="view2" class="view view2">
        <img
          class="_bg"
          src="http://minio.elfsack.com/h5material/2022shtg/2_bg.png"
        />
        <div class="_2_item_div" @click="clickView2()">
          <img
            class="_2_item _2_item1 animated bounceInRight"
            src="http://minio.elfsack.com/h5material/2022shtg/2_item1.png"
          />
          <div
            class="_2_tip animated bounceIn"
            style="
              position: absolute;
              animation-delay: 0.6s;
              top: 67%;
              left: 40%;
            "
          >
            <img
              class="animated pulse infinite"
              src="http://minio.elfsack.com/h5material/2022shtg/2_tip.png"
              style="animation-delay: 0.9s"
            />
          </div>
        </div>
        <div class="_2_item_div" @click="clickView3()">
          <img
            class="_2_item _2_item2 animated bounceInRight"
            src="http://minio.elfsack.com/h5material/2022shtg/2_item2.png"
          />

          <div
            class="_2_tip animated bounceIn"
            style="
              position: absolute;
              animation-delay: 0.9s;
              top: 73%;
              left: 75%;
            "
          >
            <img
              class="animated pulse infinite"
              src="http://minio.elfsack.com/h5material/2022shtg/2_tip.png"
              style="animation-delay: 1.2s"
            />
          </div>
        </div>
        <div class="_2_item_div" @click="clickView4()">
          <img
            class="_2_item _2_item3 animated bounceInRight"
            src="http://minio.elfsack.com/h5material/2022shtg/2_item3.png"
          />

          <div
            class="_2_tip animated bounceIn"
            style="
              position: absolute;
              animation-delay: 1.2s;
              top: 58%;
              left: 40%;
            "
          >
            <img
              class="animated pulse infinite"
              src="http://minio.elfsack.com/h5material/2022shtg/2_tip.png"
              style="animation-delay: 1.5s"
            />
          </div>
        </div>
        <div class="_2_item_div" @click="clickView5()">
          <img
            class="_2_item _2_item4 animated bounceInRight"
            src="http://minio.elfsack.com/h5material/2022shtg/2_item4.png"
          />

          <div
            class="_2_tip animated bounceIn"
            style="
              position: absolute;
              animation-delay: 1.5s;
              top: 73%;
              left: 77%;
            "
          >
            <img
              class="animated pulse infinite"
              src="http://minio.elfsack.com/h5material/2022shtg/2_tip.png"
              style="animation-delay: 1.8s"
            />
          </div>
        </div>
        <img
          class="_2_logo animated fadeInUp"
          src="http://minio.elfsack.com/h5material/2022shtg/2_logo.png"
        />
      </page>

      <!-- view3 -->
      <page index="view3" class="view view3">
        <img
          class="_3_back animated fadeIn"
          src="http://minio.elfsack.com/h5material/2022shtg/3_back.png"
          @click="backIndex()"
        />
        <div class="_swiper" id="swiper_3" style="height: 100%">
          <div class="swiper-wrapper">
            <div class="_swiper_slide swiper-slide">
              <img
                class="_bg"
                src="http://minio.elfsack.com/h5material/2022shtg/3_1_bg.png"
              />
              <img
                class="_3_img"
                src="http://minio.elfsack.com/h5material/2022shtg/3_1.png"
              />

              <div
                :class="{
                  _3_b_tip: true,
                  animated: true,
                  fadeInUp: aniImg3 == 0,
                  fadeOutDown: aniImg3 != 0,
                }"
              >
                <img
                  class="_3_tip"
                  src="http://minio.elfsack.com/h5material/2022shtg/3_tip.png"
                />
                <img
                  class="_3_logo"
                  src="http://minio.elfsack.com/h5material/2022shtg/3_logo.png"
                />
                <img
                  v-if="nextShow"
                  class="_3_next animated pulse infinite"
                  src="http://minio.elfsack.com/h5material/2022shtg/nest_tip_black.png"
                />
              </div>
            </div>
            <div class="_swiper_slide swiper-slide">
              <div style="height: 100%; width: 100%; background-color: #f6e8fd">
                <img
                  class="_3_img"
                  src="http://minio.elfsack.com/h5material/2022shtg/3_2.png"
                />
              </div>
              <div
                :class="{
                  _3_b_tip: true,
                  animated: true,
                  fadeInUp: aniImg3 == 1,
                  fadeOutDown: aniImg3 != 1,
                }"
              >
                <img
                  class="_3_tip"
                  src="http://minio.elfsack.com/h5material/2022shtg/3_tip_b.png"
                />
                <img
                  class="_3_logo"
                  src="http://minio.elfsack.com/h5material/2022shtg/3_logo_b.png"
                />
                <img
                  v-if="nextShow"
                  class="_3_next animated pulse infinite"
                  src="http://minio.elfsack.com/h5material/2022shtg/nest_tip_white.png"
                />
              </div>
            </div>
            <div class="_swiper_slide swiper-slide">
              <img
                class="_bg"
                src="http://minio.elfsack.com/h5material/2022shtg/3_3_bg.png"
              />

              <img
                class="_3_img"
                src="http://minio.elfsack.com/h5material/2022shtg/3_3.png"
              />
              <div
                :class="{
                  _3_b_tip: true,
                  animated: true,
                  fadeInUp: aniImg3 == 2,
                  fadeOutDown: aniImg3 != 2,
                }"
              >
                <img
                  class="_3_tip"
                  src="http://minio.elfsack.com/h5material/2022shtg/3_tip.png"
                />
                <img
                  class="_3_logo"
                  src="http://minio.elfsack.com/h5material/2022shtg/3_logo.png"
                />
                <img
                  v-if="nextShow"
                  class="_3_next animated pulse infinite"
                  src="http://minio.elfsack.com/h5material/2022shtg/nest_tip_black.png"
                />
              </div>
            </div>
            <div class="_swiper_slide swiper-slide">
              <img
                class="_bg"
                src="http://minio.elfsack.com/h5material/2022shtg/3_4_bg.png"
              />

              <img
                class="_3_img"
                src="http://minio.elfsack.com/h5material/2022shtg/3_4.png"
              />
              <div
                :class="{
                  _3_b_tip: true,
                  animated: true,
                  fadeInUp: aniImg3 == 3,
                  fadeOutDown: aniImg3 != 3,
                }"
              >
                <img
                  class="_3_tip"
                  src="http://minio.elfsack.com/h5material/2022shtg/3_tip.png"
                />
                <img
                  class="_3_logo"
                  src="http://minio.elfsack.com/h5material/2022shtg/3_logo.png"
                />

                <img
                  v-if="nextShow"
                  class="_3_next animated pulse infinite"
                  src="http://minio.elfsack.com/h5material/2022shtg/nest_tip_black.png"
                />
              </div>
            </div>
            <div class="_swiper_slide swiper-slide">
              <img
                class="_bg"
                src="http://minio.elfsack.com/h5material/2022shtg/3_5_bg.png"
              />

              <img
                class="_3_img"
                src="http://minio.elfsack.com/h5material/2022shtg/3_5.png"
              />
              <div
                :class="{
                  _3_b_tip: true,
                  animated: true,
                  fadeInUp: aniImg3 == 4,
                  fadeOutDown: aniImg3 != 4,
                }"
              >
                <img
                  class="_3_tip"
                  src="http://minio.elfsack.com/h5material/2022shtg/3_tip.png"
                />
                <img
                  class="_3_logo"
                  src="http://minio.elfsack.com/h5material/2022shtg/3_logo.png"
                />
                <img
                  v-if="nextShow"
                  class="_3_next animated pulse infinite"
                  src="http://minio.elfsack.com/h5material/2022shtg/nest_tip_black.png"
                />
              </div>
            </div>
            <div class="_swiper_slide swiper-slide">
              <img
                class="_bg"
                src="http://minio.elfsack.com/h5material/2022shtg/3_6_bg.png"
              />

              <img
                class="_3_img"
                src="http://minio.elfsack.com/h5material/2022shtg/3_6.png"
              />
              <div
                :class="{
                  _3_b_tip: true,
                  animated: true,
                  fadeInUp: aniImg3 == 5,
                  fadeOutDown: aniImg3 != 5,
                }"
              >
                <img
                  class="_3_tip"
                  src="http://minio.elfsack.com/h5material/2022shtg/3_tip.png"
                />
                <img
                  class="_3_logo"
                  src="http://minio.elfsack.com/h5material/2022shtg/3_logo.png"
                />
              </div>
            </div>
          </div>
        </div>
      </page>

      <!-- view4 -->
      <page index="view4" class="view view4">
        <img
          class="_bg"
          src="http://minio.elfsack.com/h5material/2022shtg/4_bg.png"
        />
        <img
          class="_4_back animated fadeIn"
          src="http://minio.elfsack.com/h5material/2022shtg/4_back.png"
          @click="backIndex()"
        />

        <img
          v-if="nextShow"
          class="_4_next animated pulse infinite"
          src="http://minio.elfsack.com/h5material/2022shtg/nest_tip_white.png"
        />

        <div class="_swiper" id="swiper_4">
          <div class="swiper-wrapper">
            <div class="_swiper_slide swiper-slide">
              <img
                :class="{
                  _4_item: true,
                  animated: true,
                  fadeInRight: aniItem4[0] == 'fadeInRight',
                  fadeOutLeft: aniItem4[0] == 'fadeOutLeft',
                  fadeInLeft: aniItem4[0] == 'fadeInLeft',
                  fadeOutRight: aniItem4[0] == 'fadeOutRight',
                }"
                src="http://minio.elfsack.com/h5material/2022shtg/4_1.png"
              />
            </div>
            <div class="_swiper_slide swiper-slide">
              <img
                :class="{
                  _4_item: true,
                  animated: true,
                  fadeInRight: aniItem4[1] == 'fadeInRight',
                  fadeOutLeft: aniItem4[1] == 'fadeOutLeft',
                  fadeInLeft: aniItem4[1] == 'fadeInLeft',
                  fadeOutRight: aniItem4[1] == 'fadeOutRight',
                }"
                src="http://minio.elfsack.com/h5material/2022shtg/4_2.png"
              />
            </div>
            <div class="_swiper_slide swiper-slide">
              <img
                :class="{
                  _4_item: true,
                  animated: true,
                  fadeInRight: aniItem4[2] == 'fadeInRight',
                  fadeOutLeft: aniItem4[2] == 'fadeOutLeft',
                  fadeInLeft: aniItem4[2] == 'fadeInLeft',
                  fadeOutRight: aniItem4[2] == 'fadeOutRight',
                }"
                src="http://minio.elfsack.com/h5material/2022shtg/4_3.png"
              />
            </div>
            <div class="_swiper_slide swiper-slide">
              <img
                :class="{
                  _4_item: true,
                  animated: true,
                  fadeInRight: aniItem4[3] == 'fadeInRight',
                  fadeOutLeft: aniItem4[3] == 'fadeOutLeft',
                  fadeInLeft: aniItem4[3] == 'fadeInLeft',
                  fadeOutRight: aniItem4[3] == 'fadeOutRight',
                }"
                src="http://minio.elfsack.com/h5material/2022shtg/4_4.png"
              />
            </div>
          </div>
        </div>

        <img
          class="_4_logo animated fadeInUp"
          src="http://minio.elfsack.com/h5material/2022shtg/4_logo.png"
        />
      </page>

      <!-- view5 -->
      <page index="view5" class="view view5">
        <img
          class="_bg"
          src="http://minio.elfsack.com/h5material/2022shtg/5_bg.png"
        />
        <img
          class="_5_back animated fadeIn"
          src="http://minio.elfsack.com/h5material/2022shtg/5_back.png"
          @click="backIndex()"
        />

        <img
          v-if="nextShow"
          class="_5_next animated pulse infinite"
          src="http://minio.elfsack.com/h5material/2022shtg/nest_tip_white.png"
        />

        <div class="_swiper" id="swiper_5">
          <div class="swiper-wrapper">
            <div class="_swiper_slide swiper-slide">
              <img
                :class="{
                  _5_item: true,
                  animated: true,
                  fadeInRight: aniItem5[0] == 'fadeInRight',
                  fadeOutLeft: aniItem5[0] == 'fadeOutLeft',
                  fadeInLeft: aniItem5[0] == 'fadeInLeft',
                  fadeOutRight: aniItem5[0] == 'fadeOutRight',
                }"
                src="http://minio.elfsack.com/h5material/2022shtg/5_1.png"
              />
            </div>
            <div class="_swiper_slide swiper-slide">
              <img
                :class="{
                  _5_item: true,
                  animated: true,
                  fadeInRight: aniItem5[1] == 'fadeInRight',
                  fadeOutLeft: aniItem5[1] == 'fadeOutLeft',
                  fadeInLeft: aniItem5[1] == 'fadeInLeft',
                  fadeOutRight: aniItem5[1] == 'fadeOutRight',
                }"
                src="http://minio.elfsack.com/h5material/2022shtg/5_2.png"
              />
            </div>
          </div>
        </div>

        <img
          class="_5_logo animated fadeInUp"
          src="http://minio.elfsack.com/h5material/2022shtg/5_logo.png"
        />
      </page>

      <!-- view6 -->
      <page index="view6" class="view view6">
        <img
          class="_6_back animated fadeIn"
          src="http://minio.elfsack.com/h5material/2022shtg/5_back.png"
          @click="backIndex()"
        />

        <img
          v-if="nextShow"
          class="_6_next animated pulse infinite"
          src="http://minio.elfsack.com/h5material/2022shtg/next_tip_black.png"
        />

        <div class="_swiper" id="swiper_6">
          <div class="swiper-wrapper">
            <div class="_swiper_slide swiper-slide">
              <img
                class="_bg"
                src="http://minio.elfsack.com/h5material/2022shtg/6_bg.png"
              />
              <img
                class="_6_hand animated lightSpeedIn"
                src="http://minio.elfsack.com/h5material/2022shtg/6_hand.png"
              />
              <img
                class="_6_title animated lightSpeedIn"
                src="http://minio.elfsack.com/h5material/2022shtg/6_title.png"
              />
              <img
                class="_6_tip animated rotateIn"
                src="http://minio.elfsack.com/h5material/2022shtg/6_tip.png"
              />
              <img
                class="_6_title_2 animated bounceIn"
                src="http://minio.elfsack.com/h5material/2022shtg/6_title_2.png"
              />
            </div>
            <div class="_swiper_slide swiper-slide">
              <img
                class="_bg"
                src="http://minio.elfsack.com/h5material/2022shtg/6_bg.png"
              />
              <img
                class="_6_text animated fadeInDownBig"
                src="http://minio.elfsack.com/h5material/2022shtg/6_text.png"
              />
              <img
                class="_6_logo animated fadeInUp"
                src="http://minio.elfsack.com/h5material/2022shtg/6_logo.png"
              />
            </div>
            <div class="_swiper_slide swiper-slide">
              <img
                class="_bg"
                src="http://minio.elfsack.com/h5material/2022shtg/6_bg_2.png"
              />
              <!-- <div
                style="overflow: hidden; display: flex; justify-content: center"
              >
                <img
                  ref="form6"
                  class="_6_form animated fadeInDownBig"
                  src="http://minio.elfsack.com/h5material/2022shtg/6_form.png"
                />
                <input
                  class="_6_input"
                  v-model="pid"
                  @keyup.enter="submit"
                  :style="'top:calc(50% + ' + input6Top + 'px)'"
                />
              </div> -->
              <img
                class="_6_form animated fadeInDownBig"
                src="http://minio.elfsack.com/h5material/2022shtg/6_form.png"
              />
              <input class="_6_input" v-model="pid" />

              <div
                :class="{
                  _save_res: true,
                  _save_res_show: !showSave,
                }"
                @click="submit"
              >
                提交
              </div>
              <div
                :class="{
                  _save_res: true,
                  _save_res_show: showSave,
                }"
              >
                长按保存
                <img class="_save_img" :src="base64" />
                <div class="_re_submit" @click="reSubmit">重新提交</div>
              </div>
            </div>
          </div>
        </div>
      </page>
    </pages>

    <audio
      id="bgmPlay"
      src="http://minio.elfsack.com/h5material/2022shtg/bgm.mp3"
      class="media-audio"
      loop
      autoplay
      preload
      ref="bgmPlay"
    ></audio>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";

export default {
  name: "app",
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      htmlWidth: 0,
      htmlHeight: 0,
      transform50: "",
      pageIndex: "view1",
      name: "",
      mobile: "",
      address: "",

      swiper3: null,
      swiper4: null,
      swiper5: null,
      swiper6: null,

      aniImg3: 0,

      aniItem4: ["", "", "", ""],
      aniItem5: ["", ""],

      pid: "",
      input6Top: 0,

      nextShow: false,
      base64: null,
      showSave: false,
      reShowSave: false,
    };
  },
  created() {
    let _this = this;

    // 设置标题
    document.title = "上海龙之梦新店开业|人间乐园梦境攻略";

    var htmlWidth = window.innerWidth;
    var htmlHeight = window.innerHeight;

    // 屏幕高度、宽度
    _this.htmlHeight = htmlHeight;
    _this.htmlWidth = htmlWidth;

    if (!navigator.userAgent.match(/AppleWebKit.*Mobile.*/)) {
      _this.pageIndex = "mobile";
    }

    document.addEventListener(
      "WeixinJSBridgeReady",
      function () {
        _this.playBgm();

        // 屏幕高度、宽度
        _this.htmlHeight = htmlHeight;
        _this.htmlWidth = htmlWidth;
      },
      false
    );

    let appId = "wx78058959e36d4115";
    let url = window.location.href.split("#")[0];

    _this.$http
      .post(
        "http://gw.api.elfsack.com/open/api/wechat/common/createApiTicket",
        {
          appId: appId,
          url: url,
        }
      )
      .then(function (response) {
        if (response.data.code == "1") {
          let retData = response.data.data;
          wx.config({
            debug: false,
            appId: appId, // 必填，公众号的唯一标识
            timestamp: retData.timestamp, // 必填，生成签名的时间戳
            nonceStr: retData.nonceStr, // 必填，生成签名的随机串
            signature: retData.signature, // 必填，签名，见附录1
            jsApiList: [
              "onMenuShareTimeline",
              "onMenuShareAppMessage",
              "onMenuShareQQ",
              "onMenuShareWeibo",
              "onMenuShareQZone",
              "chooseImage",
              "previewImage",
              "uploadImage",
              "downloadImage",
              "getNetworkType",
              "openLocation",
              "getLocation",
              "hideOptionMenu",
              "showOptionMenu",
              "hideMenuItems",
              "showMenuItems",
              "hideAllNonBaseMenuItem",
              "showAllNonBaseMenuItem",
              "closeWindow",
              "scanQRCode",
              "updateAppMessageShareData",
              "updateTimelineShareData",
            ],
          });

          var wxshare = {
            initcont1: {
              title: "上海龙之梦新店开业|人间乐园梦境攻略",
              desc: "妖精的口袋重金打造【人间乐园】好看|好逛|好玩|好拍|好多羊毛薅~",
              link: "http://h5.elfsack.com/2022shtg/", // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: "http://minio.elfsack.com/h5material/common/share.jpg", // 分享图标
            },
          };
          wx.ready(function () {
            wx.onMenuShareAppMessage(wxshare.initcont1);
            wx.onMenuShareTimeline(wxshare.initcont1);
            wx.onMenuShareQQ(wxshare.initcont1);
            wx.onMenuShareWeibo(wxshare.initcont1);
            wx.onMenuShareQZone(wxshare.initcont1);
            wx.updateAppMessageShareData(wxshare.initcont1);
            wx.updateTimelineShareData(wxshare.initcont1);
          });
        }
      });
  },
  mounted() {
    // 记录浏览量
    this.saveBrowse();
  },
  methods: {
    playBgm() {
      this.$refs.bgmPlay.play();
    },
    stopBgm() {
      this.$refs.bgmPlay.pause();
    },
    saveBrowse() {
      let _this = this;
      _this.$http
        .post("http://digital.api.elfsack.com/h5/browse", {
          page: "2022shtg",
        })
        .then(function (response) {});
    },
    saveStart() {
      let _this = this;
      _this.$http
        .post("http://digital.api.elfsack.com/h5/operate", {
          page: "2022shtg",
          operate: "start",
        })
        .then(function (response) {});
    },
    initSwiper3() {
      var _this = this;
      if (_this.swiper3 != null) {
        _this.swiper3.slideTo(0);
        return;
      }
      _this.swiper3 = new Swiper("#swiper_3", {
        followFinger: false,
        speed: 1000,
        mousewheel: true,
        on: {
          init: function (swiper) {
            _this.aniImg3 = 0;
          },
          slideChangeTransitionStart: function () {
            if (this.realIndex == 5) {
              _this.nextShow = false;
            } else {
              _this.nextShow = true;
            }
            _this.aniImg3 = this.realIndex;
          },
        },
      });
    },
    initSwiper4() {
      var _this = this;
      if (_this.swiper4 != null) {
        _this.swiper4.slideTo(0);
        return;
      }
      _this.swiper4 = new Swiper("#swiper_4", {
        followFinger: false,
        speed: 300,
        mousewheel: true,
        on: {
          init: function (swiper) {
            _this.aniItem4[0] = "fadeInRight";
            _this.aniItem4 = _this.aniItem4.concat();
          },
          slideChangeTransitionStart: function () {
            if (this.realIndex == 3) {
              _this.nextShow = false;
            } else {
              _this.nextShow = true;
            }
            if (this.previousIndex < this.realIndex) {
              _this.aniItem4[this.previousIndex] = "fadeOutLeft";
              _this.aniItem4[this.realIndex] = "fadeInRight";
            } else {
              _this.aniItem4[this.previousIndex] = "fadeOutRight";
              _this.aniItem4[this.realIndex] = "fadeInLeft";
            }
            _this.aniItem4 = _this.aniItem4.concat();
          },
        },
      });
    },
    initSwiper5() {
      var _this = this;
      if (_this.swiper5 != null) {
        _this.swiper5.slideTo(0);
        return;
      }
      _this.swiper5 = new Swiper("#swiper_5", {
        followFinger: false,
        speed: 300,
        mousewheel: true,
        on: {
          init: function (swiper) {
            _this.aniItem5[0] = "fadeInRight";
            _this.aniItem5 = _this.aniItem5.concat();
          },
          slideChangeTransitionStart: function () {
            if (this.realIndex == 1) {
              _this.nextShow = false;
            } else {
              _this.nextShow = true;
            }
            if (this.previousIndex < this.realIndex) {
              _this.aniItem5[this.previousIndex] = "fadeOutLeft";
              _this.aniItem5[this.realIndex] = "fadeInRight";
            } else {
              _this.aniItem5[this.previousIndex] = "fadeOutRight";
              _this.aniItem5[this.realIndex] = "fadeInLeft";
            }
            _this.aniItem5 = _this.aniItem5.concat();
            console.log(_this.aniItem5);
          },
        },
      });
    },
    initSwiper6() {
      var _this = this;
      if (_this.swiper6 != null) {
        _this.swiper6.slideTo(0);
        return;
      }
      _this.swiper6 = new Swiper("#swiper_6", {
        on: {
          slideChangeTransitionStart: function () {
            if (this.realIndex == 2) {
              _this.nextShow = false;
            } else {
              _this.nextShow = true;
            }
          },
        },
      });
    },
    backIndex() {
      this.pageIndex = "view2";
    },
    clickView1() {
      this.pageIndex = "view2";
      this.saveStart();
      this.playBgm();
    },
    clickView2() {
      this.pageIndex = "view3";
      this.nextShow = true;
      this.$nextTick(function () {
        this.initSwiper3();
      });
    },
    clickView3() {
      this.pageIndex = "view4";
      this.nextShow = true;
      this.$nextTick(function () {
        this.initSwiper4();
      });
    },
    clickView4() {
      this.pageIndex = "view5";
      this.nextShow = true;
      this.$nextTick(function () {
        this.initSwiper5();
      });
    },
    clickView5() {
      this.pageIndex = "view6";
      this.nextShow = true;
      this.$nextTick(function () {
        // this.input6Top = (this.$refs.form6.offsetHeight / 2) * 0.74;
        this.initSwiper6();
      });
    },
    submit() {
      let _this = this;
      console.log(_this.pid);

      if (!_this.pid) {
        alert("需要先填写ID哦~");
        return;
      }

      const canvas = document.getElementById("canvas");
      canvas.width = 564;
      canvas.height = 1222;
      const context = canvas.getContext("2d");
      const img = new Image();
      img.src = "http://minio.elfsack.com/h5material/2022shtg/6_form.png";
      img.crossOrigin = "Anonymous";
      img.onload = () => {
        context.drawImage(img, 0, 0, 564, 1222);
        context.font = "25px Verdana";
        context.fillStyle = "#2f440e";
        context.fillText(_this.pid, 249, 1005);
        _this.base64 = canvas.toDataURL("image/png");
      };

      // 保存地址
      _this.$http
        .post("http://digital.api.elfsack.com/shtg2022/save", {
          pid: _this.pid,
        })
        .then(function (response) {
          if (response.data.code == "1") {
            this.showSave = true;
          } else {
            alert("活动太火爆了！请稍后重试");
          }
        });
    },
    mergeImgs(list, cwith = 500, cheight = 1000) {
      return new Promise((resolve, reject) => {
        const baseList = [];
        // 创建 canvas 节点并初始化
        const canvas = document.createElement("canvas");
        canvas.width = cwith;
        canvas.height = cheight * list.length;
        const context = canvas.getContext("2d");
        list.map((item, index) => {
          const img = new Image();
          img.src = item;
          // 跨域
          img.crossOrigin = "Anonymous";
          img.onload = () => {
            context.drawImage(img, 0, cheight * index, cwith, cheight);
            const base64 = canvas.toDataURL("image/png");
            baseList.push(base64);
            if (baseList[list.length - 1]) {
              // 返回新的图片
              resolve(baseList[list.length - 1]);
            }
          };
        });
      });
    },
    reSubmit() {
      let _this = this;
      _this.pid = "";
      _this.base64 = "";
      _this.showSave = false;
    },
  },
};
</script>



<style lang="scss">
* {
  margin: 0;
  padding: 0;
}

._qc_v {
  text-align: center;
  font-size: 18px;
  width: 200px;
  z-index: 99;
  animation-delay: 0.2s;
  ._qc_t {
    background-color: #2b2a2f;
    color: #fff;
    text-align: center;
    padding: 10px;
    font-size: 14px;
  }
  ._qc_p {
    width: 100%;
    position: unset;
  }
}

.view {
  height: 100%;
  width: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  overflow: hidden;
  position: relative;

  img {
    position: absolute;
  }
}

._bg {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  object-fit: cover;
}

._bgm {
  position: absolute;
  top: 2%;
  right: 3%;
  z-index: 99;
  object-fit: contain;
}

._swiper {
  width: 100%;
  height: 100%;
  z-index: 2;
}

._swiper_slide {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

._bgm0 {
  width: 30px;
  height: 30px;
}
._bgm1 {
  width: 30px;
  height: 30px;
}

.view1 {
  ._1_title {
    width: 98%;
    top: 1%;
    height: 21%;
    object-fit: contain;
  }

  ._1_btn {
    height: 100%;
    max-width: 75%;
    object-fit: contain;
    position: unset;
    animation-delay: 0.3s;
  }

  ._1_tip {
    height: 80%;
    max-width: 20%;
    object-fit: contain;
    position: unset;
    margin-left: 2%;
    animation-delay: 0.5s;
  }

  ._1_logo {
    height: 30%;
    max-width: 80%;

    -o-object-fit: contain;
    object-fit: contain;
    display: inline-block;
    -webkit-animation-delay: 0.7s;
    animation-delay: 0.7s;
    position: unset;
  }
}

.view2 {
  ._2_item_div {
    width: 95%;
    height: 23%;
    margin-bottom: 0.5%;
    position: relative;
  }

  ._2_item {
    width: 100%;
    height: 100%;
    object-fit: contain;
    position: unset;
  }

  ._2_item2 {
    animation-delay: 0.1s;
  }

  ._2_item3 {
    animation-delay: 0.4s;
  }

  ._2_item4 {
    animation-delay: 0.7s;
  }

  ._2_logo {
    position: unset;
    object-fit: contain;
    width: 80%;
    height: 3%;
    z-index: 1;
    margin: 0.5% 0 2% 0;
    animation-delay: 1.4s;
  }

  ._2_tip {
    width: 14%;
    height: 22%;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}

.view3 {
  ._3_back {
    top: 0%;
    left: 3%;
    width: 8%;
    height: 8%;
    object-fit: contain;
    z-index: 10;
  }

  ._3_img {
    width: 100%;
    -o-object-fit: contain;
    object-fit: contain;
    z-index: 99;
    bottom: 0;
    left: 0;
  }
  ._3_1_look {
    position: unset;
    width: 90%;
    height: 75%;
    object-fit: contain;
  }
  ._3_1_goods {
    position: unset;
    width: 90%;
    height: 25%;
    object-fit: contain;
    margin: 4% 0;
  }
  ._3_tip {
    position: unset;
    display: inline-block;
    width: 85%;
    height: 4%;
    object-fit: contain;
  }
  ._3_logo {
    position: unset;
    display: inline-block;
    width: 35%;
    height: 2.6%;
    object-fit: contain;
    margin: 3% 0;
  }

  ._3_next {
    height: 12%;
    position: absolute;
    right: 5%;
    bottom: 0;
    font-size: 12px;
  }

  ._3_b_tip {
    position: absolute;
    bottom: 1%;
    right: 0;
    z-index: 999;
    text-align: center;
  }
}

.view4 {
  ._4_back {
    top: 0%;
    left: 3%;
    width: 8%;
    height: 8%;
    z-index: 10;
    object-fit: contain;
  }

  ._4_next {
    height: 1.5%;
    bottom: 1%;
    right: 5%;
    object-fit: contain;
    z-index: 10;
    animation-delay: 1s;
  }

  ._4_item {
    top: 0%;
    left: 0%;
    width: 95%;
    height: 90%;
    padding: 2.5%;
    object-fit: contain;
    animation-duration: 0.5s;
  }

  ._4_logo {
    bottom: 3%;
    width: 50%;
    height: 3%;
    object-fit: contain;
    animation-delay: 0.5s;
  }
}

.view5 {
  ._5_back {
    top: 0%;
    left: 3%;
    width: 8%;
    height: 8%;
    z-index: 10;
    object-fit: contain;
  }

  ._5_next {
    height: 1.5%;
    bottom: 1%;
    right: 5%;
    object-fit: contain;
    z-index: 10;
    animation-delay: 1s;
  }

  ._5_item {
    top: 0%;
    left: 0%;
    width: 95%;
    height: 90%;
    padding: 2.5%;
    object-fit: contain;
    animation-duration: 0.5s;
  }

  ._5_logo {
    bottom: 3%;
    width: 50%;
    height: 3%;
    object-fit: contain;
    animation-delay: 0.5s;
  }
}

.view6 {
  ._6_back {
    top: 0%;
    left: 3%;
    width: 8%;
    height: 8%;
    z-index: 10;
    object-fit: contain;
  }

  ._6_next {
    height: 1.5%;
    bottom: 1%;
    right: 5%;
    object-fit: contain;
    z-index: 10;
    animation-delay: 1s;
  }

  ._6_hand {
    top: 1%;
    right: -2%;
    height: 10%;
    object-fit: contain;
    animation-delay: 1.8s;
  }

  ._6_title {
    top: 0;
    height: 25%;
    object-fit: contain;
    animation-delay: 1s;
  }

  ._6_tip {
    top: 24%;
    left: 5%;
    width: 90%;
    height: 47%;
    object-fit: contain;
    animation-delay: 0.2s;
  }

  ._6_title_2 {
    bottom: 0%;
    left: 2.5%;
    width: 95%;
    height: 28%;
    object-fit: contain;
    animation-delay: 1s;
  }

  ._6_text {
    top: 0%;
    left: 0%;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  ._6_logo {
    bottom: 3%;
    width: 50%;
    height: 3%;
    object-fit: contain;
  }

  ._6_form {
    height: 90%;
    object-fit: contain;
    top: 5%;
  }

  ._6_input {
    position: absolute;
    top: 76.8%;
    left: 45%;
    width: 34%;
    height: 3%;
    background-color: #f7d13a;
    border: none;
    outline: none;
    font-size: 14px;
    font-weight: bold;
    color: #2f440e;
    z-index: 99;
    caret-color: #2f440e;
  }

  ._save_res {
    position: absolute;
    top: 83%;
    height: 6%;
    width: 35%;
    background-color: #2f440e;
    border-radius: 50px;
    color: #e4ff76;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 1s;
    transform: scale(0);
  }



  ._save_res_show {
    transform: scale(1);
  }

  ._save_img {
    width: 100%;
    height: 100%;
    opacity: 0;
  }

  ._re_submit {
    position: absolute;
    font-size: 12px;
    bottom: -50%;
    color: #2f440e;
    font-weight: bold;
  }
}
</style>
